<template>
  <base-image
    :src="image.src"
    :fallback-src="image.fallbackSrc"
    :image-class="imageClass"
    alt="Prize Image"
  ></base-image>
</template>

<script>
import BaseImage from './BaseImage'
import { mapGetters } from 'vuex';

export default {
  name: 'PrizeSingleDisplayModeImage',
  components: {BaseImage},
  props: {
    imageClass: {
      type: [Object, Array, String],
      default: ''
    }
  },
  computed: {

    ...mapGetters('i18n', [
      'getTranslations'
    ]),

    image () {
      return {
        src: this.getTranslations.visitor_prizes_daily_prize_img || `/static/images/prizes/prize_monthly_${localStorage.getItem('locale')}.png`,
        fallbackSrc: '/static/images/prizes/prize_monthly_AR.png'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/image/PrizeSingleDisplayModeImage.vue